import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { Employment } from 'src/app/shared/models/employment.model';

const REQUIRED_FIELD_MESSAGE = 'You must enter a value';

@Component({
  selector: 'app-employment-form',
  templateUrl: './employment-form.component.html',
  styleUrls: ['./employment-form.component.scss'],
  standalone: false
})
export class EmploymentFormComponent implements OnInit {
  @Output() addEmployment: EventEmitter<Employment> = new EventEmitter<Employment>();
  @Output() updateEmployment: EventEmitter<Employment> = new EventEmitter<Employment>();
  @Output() cancelPressed: EventEmitter<void> = new EventEmitter<void>();
  @Input() employment: Employment;
  @ViewChild('employer', { static: false }) employerInput: any;


  form: UntypedFormGroup;
  loading: boolean;
  errorMessage: string;
  updateEmploymentSubscription: any;
  isUpdating: boolean;
  maxDate: Date = new Date();

  constructor(private readonly fb: UntypedFormBuilder,
    private registrationService: RegistrationService,
    private datePipe: DatePipe) {
    this.loading = false;
    this.errorMessage = undefined;
    this.form = this.createForm();
  }

  ngOnInit() {
    const model = this.employment;
    if (model) {
      this.populateForm(model);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.employerInput?.nativeElement?.focus();
    }, 0);
  }

  onSubmit() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;
    const model = this.prepareSaveModel();

    if (this.isUpdating) {
      model.id = this.employment.id;
      this.updateEmployment.emit(model);
      this.isUpdating = false;
    } else {
      this.addEmployment.emit(model);
    }

    this.loading = false;
  }

  get employer() { return this.form.get('employer'); }
  get fromDate() { return this.form.get('fromDate'); }
  get toDate() { return this.form.get('toDate'); }
  get position() { return this.form.get('position'); }

  getEmployerErrorMessage() {
    return this.employer.errors.required ? REQUIRED_FIELD_MESSAGE : '';
  }

  getFromDateErrorMessage() {
    return this.fromDate.errors.required ? REQUIRED_FIELD_MESSAGE : '';
  }

  getToDateErrorMessage() {
    return this.toDate.errors.required ? REQUIRED_FIELD_MESSAGE : '';
  }

  getPositionErrorMessage() {
    return this.position.errors.required ? REQUIRED_FIELD_MESSAGE : '';
  }

  onCancel() {
    this.cancelPressed.emit();
  }

  private createForm(): UntypedFormGroup {
    const form = this.fb.group({
      employer: ['', Validators.required],
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      position: ['', Validators.required],
      id: ['']
    });

    return form;
  }

  private prepareSaveModel(): Employment {
    const formModel = this.form.value;

    const model = {
      employer: formModel.employer as string,
      fromDate: this.datePipe.transform(formModel.fromDate, 'yyyymmdd') as string,
      toDate: this.datePipe.transform(formModel.toDate, 'yyyymmdd') as string,
      position: formModel.position as string,
    };


    return model as Employment;
  }

  private populateForm(employment: Employment): void {
    this.isUpdating = true;

    this.form.setValue({
      employer: employment.employer,
      fromDate: employment.fromDate,
      toDate: employment.toDate,
      position: employment.position,
      id: employment.id,
    });
  }

}
